import React, { useState } from 'react';
import './UserInput.css';

const UserInput = ({ onSendMessage, disabled, isGeneratingResponse }) => {
  const [message, setMessage] = useState('');
  const [charCount, setCharCount] = useState(0);
  const maxChars = 500;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (message.trim() && !disabled) {
      onSendMessage(message.trim());
      setMessage('');
      setCharCount(0);
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (value.length <= maxChars) {
      setMessage(value);
      setCharCount(value.length);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  return (
    <div className="user-input-container">
      <form onSubmit={handleSubmit} className="user-input-form">
        <div className="input-wrapper">
          <textarea
            value={message}
            onChange={handleInputChange}
            onKeyPress={handleKeyPress}
            placeholder={
              disabled 
                ? (isGeneratingResponse ? "AI is thinking..." : "Start the conversation to participate...")
                : "Type your message... (Use @ to mention a therapist)"
            }
            disabled={disabled}
            className={`message-input ${disabled ? 'disabled' : ''}`}
            rows="1"
          />
          
          <div className="input-controls">
            <div className="char-counter">
              {charCount}/{maxChars}
            </div>
            
            <button
              type="button"
              className="attach-button"
              title="Attach File"
              disabled={disabled}
            >
              📎
            </button>
            
            <button
              type="submit"
              className="send-button"
              disabled={disabled || !message.trim()}
              title="Send Message"
            >
              📤
            </button>
          </div>
        </div>
      </form>
      
      {disabled && !isGeneratingResponse && (
        <div className="input-disabled-message">
          <span>💡 Select a topic and start the conversation to participate</span>
        </div>
      )}
      
      {isGeneratingResponse && (
        <div className="ai-generating-message">
          <span>🤖 AI therapist is composing a response...</span>
        </div>
      )}
    </div>
  );
};

export default UserInput;
